import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";
import { jsx as _jsx } from "react/jsx-runtime";
createRoot(document.getElementById("root")).render(/*#__PURE__*/ _jsx(BrowserRouter, { children: /*#__PURE__*/ _jsx(App, {}) }));
